/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-shadow */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-underscore-dangle */
import {
  CreateLogStreamCommand,
  CreateLogStreamCommandInput,
  DescribeLogStreamsCommand,
  DescribeLogStreamsCommandInput,
  PutLogEventsCommand,
  PutLogEventsCommandInput,
} from "@aws-sdk/client-cloudwatch-logs";
import { LogGroupName } from "../../routes/constants";
import { cwlClient } from "../cloudWatchLogsClient";

interface SequenceTokens {
  frontError: string | null;
}

class Logger {
  private _sequenceTokens: SequenceTokens = {
    frontError: null,
  };

  /**
   * 日付のprefix
   */
  private _datePrefix = `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`;

  /**
   * 日付のprefixを取得する
   */
  private get datePrefix() {
    return this._datePrefix;
  }

  /**
   * シークエンストークンを取得する
   */
  private get sequenceTokens() {
    return this._sequenceTokens;
  }

  /**
   * 次のリクエスト時に利用するシークエンストークンを保存する
   */
  private set nextErrorSequenceToken(token: string) {
    this._sequenceTokens.frontError = token;
  }

  /**
   * DescribeLogStreams APIを実行する
   * @param params
   * @returns
   */
  // eslint-disable-next-line class-methods-use-this
  private async describeLogStream(params: DescribeLogStreamsCommandInput) {
    const command = new DescribeLogStreamsCommand(params);
    try {
      return await cwlClient.send(command);
    } catch (err) {
      if (err instanceof Error) {
        throw err;
      } else {
        console.error(err.message);
        throw new Error("describeLogStream error");
      }
    }
  }

  /**
   * PutLogEvents APIを実行する
   * @param params
   * @returns
   */
  private async putLogEvents(params: PutLogEventsCommandInput) {
    const command = new PutLogEventsCommand(params);
    try {
      return await cwlClient.send(command);
    } catch (err) {
      if (err instanceof Error) {
        throw err;
      } else {
        console.error(err.message);
        throw new Error("putLogEvents error");
      }
    }
  }

  /**
   * CreateLogStream APIを実行する
   * @param params
   * @returns
   */
  private async createLogStream(params: CreateLogStreamCommandInput) {
    const command = new CreateLogStreamCommand(params);

    try {
      return await cwlClient.send(command);
    } catch (err) {
      if (err instanceof Error) {
        throw err;
      } else {
        console.error(err.message);
        throw new Error("createLogStream error");
      }
    }
  }

  /**
   * frontErrorログの出力を行う
   * @param message
   */
  public async frontError(message: any) {
    const logGroupName = LogGroupName.frontError;
    const logStreamName = `frontError_${this.datePrefix}`;

    const params: DescribeLogStreamsCommandInput = {
      logGroupName,
      logStreamNamePrefix: logStreamName,
    };

    // sequenceTokenが存在しなければ取得を試みる
    if (!this.sequenceTokens?.frontError) {
      const res = await this.describeLogStream(params);
      // tokenが存在すれば格納
      const findStreamError = res.logStreams?.find(stream => stream.logStreamName === params.logStreamNamePrefix);

      // logStreamが存在しなかった場合作成
      if (!findStreamError) {
        const params: CreateLogStreamCommandInput = {
          logGroupName,
          logStreamName,
        };
        await this.createLogStream(params);
      }

      // sequenceTokenを取得できたら格納する
      if (findStreamError?.uploadSequenceToken) {
        this.nextErrorSequenceToken = findStreamError.uploadSequenceToken;
      }
    }

    try {
      const params: PutLogEventsCommandInput = {
        logGroupName,
        logStreamName,
        logEvents: [
          {
            timestamp: new Date().getTime(),
            message,
          },
        ],
        sequenceToken: this.sequenceTokens.frontError ? this.sequenceTokens.frontError : undefined,
      };

      const res = await this.putLogEvents(params);
      if (res?.nextSequenceToken) {
        this.nextErrorSequenceToken = res.nextSequenceToken;
      }
    } catch (err) {
      // eslint-disable-next-line no-constant-condition
      if (err.__type === "InvalidSequenceTokenException" || "DataAlreadyAcceptedException") {
        this.nextErrorSequenceToken = err.expectedSequenceToken;
      } else if (err instanceof Error) {
        throw err;
      } else {
        console.error(err.message);
        throw new Error("putLogEvents error");
      }
    }
  }
}

const logger = new Logger();
export default logger;
